<template>
<transition name="scale">

    <div class="centertext emptylist"  >
<img :src="$imgUrl('empty.png')" />
<slot></slot>

    </div>

</transition>
</template>

<script>
'use strict';
export default {
  name: 'emptylist',
  data() {
    return {
     
     
    }
  },
  methods: {
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emptylist {
margin-top:6em;
margin-left:auto;
margin-right:auto;
}

</style>



// WEBPACK FOOTER //
// emptylist.vue?4d3501e0